<script>
    import TextField from "./TextField.svelte";

    export let value = "";
    export let label = "Title";
    export let help = "Title of the object";
    export let options = {};
    export let style;
</script>

<TextField
        bind:value={value}
        {label}
        {help}
        {style}
        icon="http"/>